import { JsonObject, JsonProperty } from 'json2typescript'
import { DefinedListDetail } from '../DefinedList'
import Model from '../Model'

@JsonObject('SpecifiedItem')
export default class SpecifiedItem extends Model {
  @JsonProperty('typeOfItem', DefinedListDetail)
  typeOfItem: DefinedListDetail

  @JsonProperty('insuredItemsCarriedOutsideProperty', Boolean)
  insuredItemsCarriedOutsideProperty: boolean

  insuredItemsCarriedOutsidePropertytext: string | null = null

  @JsonProperty('replacementCost', Number)
  replacementCost: number

  @JsonProperty('specifiedItemDescription', String)
  specifiedItemDescription: string

  @JsonProperty('prn', Number)
  prn: number | null

  constructor(
    id = 0,
    typeOfItem = new DefinedListDetail(),
    insuredItemsCarriedOutsideProperty = false,
    replacementCost = 0,
    specifiedItemDescription = '',
    insuredItemsCarriedOutsidePropertytext = '',
    prn = null,
  ) {
    super(id)
    this.typeOfItem = typeOfItem
    this.insuredItemsCarriedOutsideProperty = insuredItemsCarriedOutsideProperty
    this.replacementCost = replacementCost
    this.specifiedItemDescription = specifiedItemDescription
    this.insuredItemsCarriedOutsidePropertytext = insuredItemsCarriedOutsidePropertytext
    this.prn = prn
  }
}
